import React, { Component } from 'react'
import ReactHighcharts from 'react-highcharts'
import PropTypes from 'prop-types'
const formatDataHeadmap = data => {
  return data
    .filter(d => d[1])
    .reduce((acomulador, current) => {
      let date = new Date(current[0])
      let x = `${date.getFullYear()}-${date.getMonth()}-${date.getDate() + 1}`
      let y = date.getHours()
      if (acomulador.length === 0) {
        acomulador.push([x, y, current[1], 1])
      } else {
        let lastValue = acomulador[acomulador.length - 1]
        if (lastValue[0] === x && lastValue[1] === y) {
          acomulador.pop()
          acomulador.push([x, y, lastValue[2] + current[1], lastValue[3] + 1])
        } else {
          acomulador.push([x, y, current[1], 1])
        }
      }
      return acomulador
    }, [])
    .map(t => [Date.UTC(...t[0].split('-')), t[1], Math.floor(t[2] / t[3] * 100) / 100])
}

class Heatmap extends Component {
  shouldComponentUpdate () { return false }

  render () {
    const data = window.innerWidth < 700
      ? this.props.data.slice(-99999)
      : this.props.data.slice(-999999)

    const config = {
      time: { useUTC: false, timezone: 'America/Bogota' },
      chart: { type: 'heatmap', height: this.props.height || 350 },
      exporting: {
        filename: this.props.title,
        enabled: true,
        showTable: false,
        buttons: {
          contextButton: { menuItems: ['downloadPNG', 'downloadSVG'] }
        }
      },
      yAxis: {
        min: 0,
        max: 23,
        title: { text: null },
        labels: { format: '{value}:00' },
        tickPositions: [0, 6, 12, 18, 23]
      },
      xAxis: {
        type: 'datetime',
        min: data[0][0],
        max: data[data.length - 1][0],
        tickInterval: 48 * 3600 * 1000,
        labels: { format: '{value:%b-%d}' }
      },
      colorAxis: {
        stops: this.props.stops,
        min: this.props.range[0],
        max: this.props.range[1],
        startOnTick: false,
        endOnTick: false,
        labels: { format: `{value}${this.props.unit}` }
      },
      credits: { text: 'Innova', href: 'http://www.innovatecnologia.com/' },
      title: { text: this.props.title },
      series: [{
        boostThreshold: 100,
        nullColor: '#EFEFEF',
        colsize: 24 * 36e5,
        data: formatDataHeadmap(data),
        turboThreshold: Number.MAX_VALUE,
        tooltip: {
          headerFormat: `${this.props.title}<br/>`,
          pointFormat: `{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} ${this.props.unit}</b>`
        }
      }]
    }
    return (
      <div ref='container' style={{ padding: '10px' }}>
        <ReactHighcharts config={config} ref='chart' />
      </div>
    )
  }
}

Heatmap.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  stops: PropTypes.array,
  ylabel: PropTypes.string,
  height: PropTypes.number,
  unit: PropTypes.string
}

export default Heatmap



// WEBPACK FOOTER //
// ./src/charts/Heatmap.js